import { render, staticRenderFns } from "./recycleVideo.vue?vue&type=template&id=0fc75016&scoped=true&"
import script from "./recycleVideo.vue?vue&type=script&lang=js&"
export * from "./recycleVideo.vue?vue&type=script&lang=js&"
import style0 from "./recycleVideo.vue?vue&type=style&index=0&id=0fc75016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc75016",
  null
  
)

export default component.exports